import { LayoutDashboard, CalendarCheck, CalendarDays, CalendarRange, Stethoscope, HeartPulse, ListChecks, MessageCircle, UserRound, Inbox } from "lucide-react";
import PortalLayout from "@/components/portal/PortalLayout";

const ADMIN_NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testid: "dashboard" },
  { to: "/admin/agenda", label: "Agenda settimanale", icon: CalendarRange, testid: "agenda" },
  { to: "/admin/visite", label: "Visite", icon: CalendarCheck, testid: "visits" },
  { to: "/admin/calendario", label: "Calendario medici", icon: CalendarDays, testid: "calendar" },
  { to: "/admin/medici", label: "Medici", icon: Stethoscope, testid: "doctors" },
  { to: "/admin/infermieri", label: "Infermieri", icon: HeartPulse, testid: "nurses" },
  { to: "/admin/candidature", label: "Candidature", icon: Inbox, testid: "contact-requests" },
  { to: "/admin/specialita", label: "Specialità", icon: ListChecks, testid: "specialties" },
  { to: "/admin/whatsapp", label: "WhatsApp", icon: MessageCircle, testid: "whatsapp" },
];

const DOCTOR_NAV = [
  { to: "/medico", label: "Il mio calendario", icon: CalendarDays, end: true, testid: "calendar" },
  { to: "/medico/visite", label: "Le mie visite", icon: CalendarCheck, testid: "visits" },
  { to: "/medico/profilo", label: "Profilo", icon: UserRound, testid: "profile" },
];

const NURSE_NAV = [
  { to: "/infermiere", label: "Le mie visite", icon: CalendarCheck, end: true, testid: "visits" },
  { to: "/infermiere/profilo", label: "Profilo", icon: UserRound, testid: "profile" },
];

export const AdminLayout = () => <PortalLayout nav={ADMIN_NAV} title="Amministrazione" />;
export const DoctorLayout = () => <PortalLayout nav={DOCTOR_NAV} title="Area medico" />;
export const NurseLayout = () => <PortalLayout nav={NURSE_NAV} title="Area infermiere" />;
